import { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';

import { FiArrowUpRight } from 'react-icons/fi';
import { heightSchema } from '../../utils/schemas';
import { BigInput } from '.';
import { useAssessmentContext } from '../../providers';

function HeightInput({ submitHandler }) {
    const { answers } = useAssessmentContext();

    const ft = answers.heightInches ? Math.floor(answers.heightInches / 12) : '';
    const inc = answers.heightInches ? answers.heightInches % 12 : '';

    // Autofill does not cause Formik to validate, nor count as being dirty
    // The following logic checks the autofill data to see if it is valid
    const [autofillValid, setAutofillValid] = useState(false);
    useEffect(() => {
        async function validate() {
            const valid = await heightSchema.isValid({ feet: ft, inches: inc });
            setAutofillValid(valid);
        }

        validate();
    }, [ft, inc]);

    return (
        <Formik
            initialValues={{ feet: ft, inches: inc }}
            validationSchema={heightSchema}
            onSubmit={(data) => {
                submitHandler(+data.feet * 12 + +data.inches);
            }}>
            {({ dirty, isValid }) => (
                <Form className="max-w-4xl mx-auto mb-10 relative pb-1 lg:pb-2 flex items-end justify-center space-x-5 px-6 lg:px-12">
                    <BigInput
                        name="feet"
                        type="text"
                        inputMode="numeric"
                        placeholder="FEET"
                        maxLength={1}
                        className="w-full max-w-[45%] lg:max-w-none"
                        autoFocus
                        data-attr="feet-input"
                    />
                    <BigInput
                        name="inches"
                        type="text"
                        inputMode="numeric"
                        placeholder="INCHES"
                        maxLength={2}
                        className="w-full max-w-[45%] lg:max-w-none pr-4 sm:pr-12"
                        data-attr="inches-input"
                    />
                    <button
                        type="submit"
                        // Only disable not dirty form if autofill is also not valid
                        disabled={(!dirty && !autofillValid) || !isValid}
                        className="text-lg bg-green-400 rounded-full w-8 h-8 lg:w-12 lg:h-12 absolute right-0 bottom-2 lg:top-1/2 lg:-translate-y-1/2 disabled:opacity-50">
                        <FiArrowUpRight className="absolute-center" />
                    </button>
                </Form>
            )}
        </Formik>
    );
}

export default HeightInput;
